<template>
  <section
    class="content"
    
  >
    <div>
      <div class="box-body">
        <v-server-table
          ref="operatorReportTable"
          url
          :columns="columns"
          :options="options"
          v-on:row-click="edit"
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
          <template slot="download" slot-scope="props">
            <div>
              <a role="button"  v-on:click.stop="download(props.row)">Download</a>
            </div>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import Config, { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import {mapState} from 'vuex';
import moment from 'moment';
import axios from 'axios'

export default {
name: 'OperatorReport',
  data() {
    return {
		USER_ROLES: USER_ROLES,
		loading: null,
		operatorReportTable: null,
		columns: [
			'siteCode',
			'siteName',
      'siteType',
      
      'createdAt',
      'shift',
      'download'
		],
		options: {
        highlightMatches: true,
        sortable: [
          'siteName',
			'siteType',
      'siteCode',
      'shift',
			'createdAt',
        ],

        headings: {
          	siteName : 'Location',
			siteType : 'Location Type',
      siteCode :'Location Code',
      createdAt : 'Date',
      shift:'Shift',
      download : 'Download'
		},
		templates:{
			createdAt(row,query){
				return moment(query.createdAt).format('DD-MM-YYYY')
			}
		},
		requestFunction: request => {
          const params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          // if(this.user.roleName == "GA Head"){
          //   params.regionRegionManager = this.user._id
          // }
          // if(this.user.roleName == "Journey Manager"){
          //   params.manager = this.user._id
          // }
          if (request.orderBy) {
            params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          this.loading = true;
          return this.$techchecklistDataRepository.list(params).catch(error => {
            console.error('techchecklist.requestFunction-error:', error);
            this.$snotify.error('Get Checklist', 'Error!');
          });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total,
          };
        },
        uniqueKey: '_id',
      },
    };
  },
  methods: {
    edit(data) {
      this.$router.push({
        name: 'ViewOperatorReport',
        params: {
          _id: data.row._id,
        },
        props: data.row,
      });
    },
    onLoaded() {
      this.operatorReportTable = this.$refs.operatorReportTable;
    },
    download(row){
      const params = {};
      params.reportId = row._id;
      axios({
        method: 'get',
        url:  `${Config.serverURI}/checklistReport?reportId=${row._id}`,
        responseType: 'arraybuffer'
      })
      .then((response) => {
        
        this.forceFileDownload(response,row)
      }) 
      .catch((error) => {
        this.$snotify.error('Report download failed', 'Error!')
      })
    },
    forceFileDownload(response,row){
      const url = URL.createObjectURL(new Blob([response.data], {
        type: 'application/pdf'
      }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'checklist.pdf') 
      document.body.appendChild(link)
      link.click()
    }
  },

};
</script>

<style scoped>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}
.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
.btn{
 background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
  color: white 
}
</style>


// WEBPACK FOOTER //
// OperatorReport.vue?6d53bdc6